import React from 'react';
import { CHANGELOG_LIST_PAGE_SIZE } from '../../../shared/constants/articleListPagination';
import { InfiniteListContentListPage } from '../components/InfiniteListContentListPage';
import { ChangelogCard } from '../components/changelog/ChangelogCard';
import type { ArticleRow } from '../../../shared/schemas/article';

function renderChangelogs(entries: ArticleRow[]) {
  return (
    <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
      {entries.map((entry) => (
        <ChangelogCard
          key={entry.slug}
          title={entry.title}
          excerpt={entry.excerpt ?? ''}
          slug={entry.slug}
        />
      ))}
    </div>
  );
}

export function ChangelogListPage() {
  return (
    <InfiniteListContentListPage
      title="Changelog"
      infiniteListProps={{
        emptyMessage: 'No changelog entries yet.',
        articleType: 'changelog',
        pageSize: CHANGELOG_LIST_PAGE_SIZE,
        renderItems: renderChangelogs,
      }}
    />
  );
}
